import { FirebaseApp } from 'firebase/app';
import { useContext } from 'react';
import { FbContext } from './FirebaseAuthenticated';

export const useFirebaseApp = (): FirebaseApp => {
  const firebaseApp = useContext(FbContext);
  if (!firebaseApp) {
    throw 'No firebase app in context';
  }
  return firebaseApp;
};
